export default "__VITE_ASSET__fdd7617e__"